export const XLSX_ERROR =
  'CSV processing failed. Please check internet connection and try again';
